<div class="" *ngIf="isUserLogin">
    <loading-contents *ngIf="messages == null"></loading-contents>
    <div class="main-contents" *ngIf="messages != null">
        <div class="dashborad padding-top-30">
            <div class="container">
                <dashboard-header></dashboard-header>
                <div class="row" *ngIf="messages">
                    <div class="col-lg-12 padding-bottom-15">
                        <h5>Messages ({{total}})</h5>
                    </div>
                    <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6 padding-bottom-30" *ngFor="let item of messages">
                        <div class="card">
                            <div class="card-contents">
                                <p><span class="bold">Name: </span>{{item.name}}</p>
                                <p><span class="bold">Sent form: </span>{{item.ip}}</p>
                                <p><span class="bold">Sent time: </span>{{item.createTime}}</p>
                                <p><span class="bold">Message: </span>{{item.message}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                                <button class="btn btn-outline-danger btn-sm" type="button" data-toggle="modal" attr.data-target="#item-{{item.url}}">Delete</button>
                                <!-- Modal -->
                                <div class="modal fade" id=item-{{item.url}} tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                        <h5 class="modal-title" id="centerTitle">Delete Message</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        </div>
                                        <div class="modal-body">
                                            <p>Are your sure you want to permanently remove this message?</p>
                                        </div>
                                        <div class="modal-footer">
                                            <div class="row">
                                                <div class="buttons col-lg-6">
                                                    <button type="button" class="btn btn-outline-danger" data-dismiss="modal" (click)="deleteItem(item)">Yes</button>
                                                </div>
                                                <div class="buttons col-lg-6">
                                                    <button type="button" class="btn btn-outline-light" data-dismiss="modal">Cancel</button>
                                                </div>                                               
                                            </div>                                        
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="" *ngIf="!isUserLogin">
    <app-slider></app-slider>
    <div class="loading">
        <div class="wrapper padding-top-30">
            <div class="container">
                <p>Oops, The page you are looking for can't be found!</p>
                <div class="missing-page">
                    <span class="side">4</span>
                    <span class="taiji-icon"></span>
                    <span class="side">4</span>
                </div>
                <p>Loading...</p>
            </div>
        </div>
    </div>
    <div class="socail-media padding-top-30">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <instagram-post></instagram-post>
                </div>
                <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <tumblr-posts></tumblr-posts>
                </div>
            </div>
        </div>
    </div>
</div>
